import React from "react";
import { body, eyebrow, h2, section, shell } from "../utils/styles";
export function Identification() {
  return <section className={`${shell} ${section} grid gap-3 sm:grid-cols-2 sm:gap-10 lg:gap-20`} data-id="element-97" data-mp="2l85hkzkqngzh">
      <div data-id="element-98" data-mp="2yzjx2wfft01s">
        <p className={eyebrow} data-id="element-99" data-mp="2yzbnbdem2aut">Si te pasa esto</p>
        <h2 className={h2} data-id="element-100" data-mp="2uz05079q0mmi">¿Tenés ganas de empezar, pero no sabés qué vender?</h2>
      </div>
      <div className="sm:pt-10" data-id="element-101" data-mp="279fijeecz78h">
        <p className={`${body} mb-5 text-bright`} data-id="element-102" data-mp="278nnq5sl5dj9">
          Quizás ya viste videos sobre ebooks, inteligencia artificial y negocios digitales. Pero cuando te sentás a
          hacerlo, aparecen las dudas: qué tema elegir, cómo crear el producto y cómo conseguir compradores.
        </p>
        <p className={body} data-id="element-103" data-mp="2baiwtwgrcv7l">
          En Radar Digital tenés una ruta para avanzar y encuentros conmigo para resolver lo que te frena.
        </p>
      </div>
    </section>;
}